<template>
  <v-dialog
    v-model="showDialog"
    max-width="660"
    @click:outside="cancelDialog"
    content-class="delete-dialog"
  >
    <v-card>
      <v-card-title>
        <h3>Delete <u>{{ selectedKeyToDelete.Title }}</u> key</h3>
      </v-card-title>

      <v-card-text>
        <p>Are you sure you want to delete this key?</p>
        <p>This action cannot be undone.</p>
				<!-- <p>//devnote tutaj w przyszlosci dodac notke o ewentualnych srodowiskach, do ktorych jest przypiety klucz</p> -->
      </v-card-text>

      <v-card-actions class="justify-center buttons">
        <v-btn
          text
          @click="cancelDialog"
        >
          Cancel
        </v-btn>

        <v-btn
          color="error darken-1"
          @click="confirmDialog"
          :disabled="loading"
        >
          <v-icon v-if="!loading" left>fas fa-trash</v-icon>
          <v-icon v-else left>fas fa-spinner fa-spin</v-icon>
          Delete key
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({}),
  props: ["showDeleteDialog", "selectedKeyToDelete", "loading"],
  computed: {
    showDialog: {
      get() {
        return this.showDeleteDialog;
      },
      set(value) {
        this.$emit("update:showDeleteDialog", value);
      }
    }
  },
  methods: {
    cancelDialog() {
      this.showDialog = false;
    },
    confirmDialog() {
      this.$emit("confirmDeleteDialog");
    }
  },
  created() {
    console.log("delete dialog", this.selectedKeyToDelete);
  }
};
</script>

<style scoped>
.delete-dialog h3,
p {
  font-family: "Montserrat";
  text-align: center;
}

.delete-dialog h3 {
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;
}

.delete-dialog p {
  font-weight: 500;
}

.delete-dialog p:nth-child(2) {
  margin-top: -15px;
}

.delete-dialog .buttons {
  padding-bottom: 60px;
}

.buttons {
  font: 12px/15px "Montserrat";
}
</style>